import type { IReqPage, IResPage } from '@/types/apis/base'
import type { IReqCreateVideoTask, IResCreationTaskItem, IResWorkListItem } from '@/types/apis/task'
import type { EnumTaskAssetsType, EnumTaskStatus } from '@/enums/task'
import { post } from '@/utils/http'

export type IReqCreationTaskList = IReqPage<{
  StatusArray: EnumTaskStatus[]
}>

export type IReqWorksList = IReqPage<{
  ProjectFileTypeId: EnumTaskAssetsType
  Status: EnumTaskStatus
}>

const normalizeCreationTaskSamples = (item: IResCreationTaskItem): IResCreationTaskItem => {
  const SampleImages = item.SampleImages
    ? item.SampleImages
    : [item.StartImage, item.EndImage].filter(Boolean).join(',')

  return {
    ...item,
    SampleImages,
  }
}

// 创建视频任务
export const apiCreateVideoTask = (payload: IReqCreateVideoTask) => {
  return post<number>('/UserClip/AILionDrama/AddAITextToVideoWithAutoSelection', payload)
}

// 获取视频任务列表
export const apiGetVideoTasks = (payload: IReqCreationTaskList) => {
  return post<IResPage<IResCreationTaskItem>>(
    '/UserClip/AITextToVideo/GetPagedAITextToVideoTableJsonList',
    payload,
  ).then(res => {
    res.Body.Items = res.Body.Items.map(item => normalizeCreationTaskSamples(item))
    return res
  })
}

// 获取视频任务详情
export const apiGetCreationTaskDetail = (payload: { Id: number }) => {
  return post<IResCreationTaskItem>(`UserClip/AITextToVideo/GetAITextToVideo?id=${payload.Id}`).then(res => {
    res.Body = normalizeCreationTaskSamples(res.Body)
    return res
  })
}

// 获取我的作品列表
export const apiGetWorkList = (payload: IReqWorksList) => {
  return post<IResPage<IResWorkListItem>>('/UserClip/AIWebClipProject/GetPagedAIWebClipProjectTableJsonList', payload)
}
